import Popup from '@shared/components/Popup/Popup';
import { useTranslation } from 'react-i18next';

import ModalFooter from 'components/ModalFooter';
import testingConstants from 'utils/testingConstants';

import AddParticipantsField from './AddParticipantsField/AddParticipantsField';
import InvitationMessageField from './InvitationMessageField';
import LoadingView from './LoadingView';
import useCreateNewRoomDataContext from '../CreateNewRoomDataProvider/useCreateNewRoomDataContext';
import ProgressBar from '../ProgressBar';
import { CreateNewRoomStepsEnum } from '../utils';

const InviteParticipantsStepModal = () => {
  const { t } = useTranslation();
  const {
    roomToEdit,
    handleExit,
    setCurrentStep,
    setHasToReturnToReview,
    hasToReturnToReview,
    isInviteInformationLoading,
    roomForm: {
      watch,
      setValue,
      formState: { errors },
    },
  } = useCreateNewRoomDataContext();

  const [participantsWatch, invitationMessageWatch] = watch(['participants', 'invitationMessage']);

  const handleGoBack = () => setCurrentStep(CreateNewRoomStepsEnum.CREATE_ROOM);
  const handleGoNext = () => {
    setValue('participantInput', '');
    setHasToReturnToReview(false);
    setCurrentStep(CreateNewRoomStepsEnum.REVIEW_ROOM);
  };

  const modalTitle = `${t('add_participants')} (${t('optional').toLowerCase()})`;
  const shouldDisplayNextButton = participantsWatch.length || invitationMessageWatch || roomToEdit;
  const nextOrSkipText = shouldDisplayNextButton ? t('next') : t('skip');
  const primaryButtonText = hasToReturnToReview ? t('save') : nextOrSkipText;
  const isSuccessDisabled = !!errors.invitationMessage || isInviteInformationLoading;

  return (
    <Popup isVisible>
      <Popup.FullScreenContainer className="md:w-[512px]">
        <Popup.Header className="flex-col justify-between !mx-0 px-4 pt-4 !shadow-none !border-none">
          <div className="flex w-full justify-between">
            {modalTitle}
            <Popup.CloseIcon closePopup={handleExit} className="!static" />
          </div>
          <ProgressBar />
        </Popup.Header>
        <div
          className="flex flex-col grow overflow-y-auto gap-4 p-4"
          data-testid={testingConstants.addParticipantsModal}
        >
          {isInviteInformationLoading ? (
            <LoadingView />
          ) : (
            <>
              <AddParticipantsField />
              <InvitationMessageField>
                <span className="text-size-sm text-black">{t('invitationMessage')}</span>
              </InvitationMessageField>
            </>
          )}
        </div>
        <ModalFooter
          onCloseClick={handleGoBack}
          onSubmit={handleGoNext}
          successButtonText={primaryButtonText}
          cancelText={t('back')}
          successDisabled={isSuccessDisabled}
          isCancelButtonHidden={hasToReturnToReview}
        />
      </Popup.FullScreenContainer>
    </Popup>
  );
};

export default InviteParticipantsStepModal;
